module.exports = __webpack_public_path__ + "static/media/metepecimg.fa5ca443.jpg";